__webpack_require__.p = "/3d-tours/park-malevica/_next/";